import React from 'react';
import Visualization, {SIZES} from 'components/Visualization';
import ChartTable from './ChartTable';
import './DrillVisualization.css';

class DrillVisualization extends React.Component {
  render() {
    const {
      cardId,
      filters,
      dateRangeFilter,
      filterGroupIds,
      dataControlFilters,
      onDrill,
      isTable,
    } = this.props;
    const Component = isTable ? ChartTable : Visualization;

    return (
      <div className="DrillVisualization">
        <Component
          size={SIZES.DETAILS}
          cardId={cardId}
          filters={filters}
          dateRangeFilter={dateRangeFilter}
          dataControlFilters={dataControlFilters}
          filterGroupIds={filterGroupIds}
          onDrill={onDrill}
        />
      </div>
    );
  }
}

export default DrillVisualization;
